import React from 'react';

/**
 * Ambient ethereal sparkle outlines matching the design on Home hero.
 * Supports variant='white' (for #38b6ff backgrounds) and variant='blue' (for white backgrounds with low opacity).
 */
export function SparklePattern({ variant = 'white', className = '' }) {
  const isBlue = variant === 'blue';

  return (
    <div className={`absolute inset-0 pointer-events-none -z-10 overflow-hidden ${className}`} aria-hidden="true">
      {/* Subtle soft gradient glow */}
      <div
        className={`absolute -top-32 -right-32 w-96 h-96 rounded-full blur-3xl ${
          isBlue ? 'bg-[#38b6ff]/5' : 'bg-white/10'
        }`}
      />
      <div
        className={`absolute -bottom-32 -left-32 w-96 h-96 rounded-full blur-3xl ${
          isBlue ? 'bg-[#38b6ff]/5' : 'bg-white/10'
        }`}
      />

      {/* Large wireframe sparkle - top right */}
      <svg
        className={`absolute -top-16 -right-16 w-80 h-80 sm:w-96 sm:h-96 lg:w-[460px] lg:h-[460px] stroke-[1.2] fill-none -rotate-6 transition-transform duration-1000 ${
          isBlue ? 'stroke-[#38b6ff]/20' : 'stroke-white/20'
        }`}
        viewBox="0 0 100 100"
      >
        <path d="M 50 5 C 52 28, 72 48, 95 50 C 72 52, 52 72, 50 95 C 48 72, 28 52, 5 50 C 28 48, 48 28, 50 5 Z" />
      </svg>

      {/* Medium wireframe sparkle - top left */}
      <svg
        className={`absolute -top-10 -left-10 w-48 h-48 sm:w-64 sm:h-64 lg:w-80 lg:h-80 stroke-[1.25] fill-none rotate-12 ${
          isBlue ? 'stroke-[#38b6ff]/15' : 'stroke-white/15'
        }`}
        viewBox="0 0 100 100"
      >
        <path d="M 50 5 C 52 28, 72 48, 95 50 C 72 52, 52 72, 50 95 C 48 72, 28 52, 5 50 C 28 48, 48 28, 50 5 Z" />
      </svg>

      {/* Delicate floating sparkle - center left */}
      <svg
        className={`absolute top-1/2 left-4 sm:left-12 w-14 h-14 sm:w-20 sm:h-20 stroke-[1.5] fill-none -rotate-12 ${
          isBlue ? 'stroke-[#38b6ff]/25' : 'stroke-white/25'
        }`}
        viewBox="0 0 100 100"
      >
        <path d="M 50 5 C 52 28, 72 48, 95 50 C 72 52, 52 72, 50 95 C 48 72, 28 52, 5 50 C 28 48, 48 28, 50 5 Z" />
      </svg>

      {/* Floating accent sparkle - bottom center */}
      <svg
        className={`absolute -bottom-8 left-1/3 sm:left-1/2 w-24 h-24 sm:w-32 sm:h-32 stroke-[1.2] fill-none rotate-45 ${
          isBlue ? 'stroke-[#38b6ff]/15' : 'stroke-white/15'
        }`}
        viewBox="0 0 100 100"
      >
        <path d="M 50 5 C 52 28, 72 48, 95 50 C 72 52, 52 72, 50 95 C 48 72, 28 52, 5 50 C 28 48, 48 28, 50 5 Z" />
      </svg>

      {/* Subtle tiny accent sparkle - bottom right */}
      <svg
        className={`absolute bottom-6 right-12 lg:right-24 w-12 h-12 sm:w-16 sm:h-16 stroke-[1.5] fill-none rotate-6 ${
          isBlue ? 'stroke-[#38b6ff]/20' : 'stroke-white/20'
        }`}
        viewBox="0 0 100 100"
      >
        <path d="M 50 5 C 52 28, 72 48, 95 50 C 72 52, 52 72, 50 95 C 48 72, 28 52, 5 50 C 28 48, 48 28, 50 5 Z" />
      </svg>
    </div>
  );
}

export default SparklePattern;
